import { render, staticRenderFns } from "./ReorderContent.vue?vue&type=template&id=dc7a97ea&scoped=true&"
import script from "./ReorderContent.vue?vue&type=script&lang=js&"
export * from "./ReorderContent.vue?vue&type=script&lang=js&"
import style0 from "./ReorderContent.vue?vue&type=style&index=0&id=dc7a97ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7a97ea",
  null
  
)

export default component.exports